import * as React from 'react'
import { Image, Text, View, Platform } from 'react-native'
import styled from '@theme/styled-components'

import ImagePicker from '@components/imagePicker/ImagePicker'
import CameraPicker from '@components/imagePicker/CameraPicker'

const ImageSection = () => {
  const [images, setImages] = React.useState<UploadImageIncidentRequest[]>([])

  return (
    <Section>
      <SectionTitle>Image Picker</SectionTitle>

      <Container>
        <ImagePicker onImageUploaded={setImages}>
          <PickerRender>
            <PickerText>Select picture</PickerText>
          </PickerRender>
        </ImagePicker>

        {Platform.OS !== 'web' && (
          <CameraPicker onImageUploaded={setImages}>
            <PickerRender>
              <PickerText>use camera</PickerText>
            </PickerRender>
          </CameraPicker>
        )}

        <Images>
          {images.map((im) => (
            <Picture key={im.filename} source={{ uri: im.image }} resizeMode="cover" />
          ))}
        </Images>
      </Container>
    </Section>
  )
}

export default ImageSection

const Section = styled(View)`
  padding: 24px;
  border-color: ${(props) => props.theme.colors.disable};
  border-bottom-width: 1px;
  border-style: solid;
`
const SectionTitle = styled(Text)`
  margin-bottom: 15px;
  text-decoration: underline;
  ${(props) => props.theme.fonts.LargeTitle};
`
const Container = styled(View)`
  margin-bottom: 12px;
`

const PickerRender = styled(View)`
  height: 200px;
  border: 2px dashed ${(props) => props.theme.colors.primary};
  align-items: center;
  justify-content: center;
`

const PickerText = styled(Text)`
  ${(props) => props.theme.fonts.Body};
`

const Images = styled(View)`
  flex-flow: row wrap;
  margin-top: 15px;
`

const Picture = styled(Image)`
  height: 150px;
  width: 150px;
  margin: 5px;
`
